module.exports = __webpack_public_path__ + "static/img/tit.b02ef71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/TW/img/tit.png
// module id = f08g
// module chunks = 1